import { BaseModal } from '@/components/base-modal';
import { Text } from '@lego/klik-ui';
import type { RefObject } from 'react';

type CopyConfirmModalProps = {
  isOpen: boolean;
  isLoading?: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  onClose: () => void;
  onConfirm: () => void;
};

export const CopyConfirmModal = ({
  isOpen,
  isLoading,
  triggerRef,
  onClose,
  onConfirm,
}: CopyConfirmModalProps) => (
  <BaseModal
    isOpen={isOpen}
    triggerRef={triggerRef}
    onClose={onClose}
    title="Confirm Publishing"
    rightButtonProps={{
      text: 'Confirm & publish',
      'aria-label': 'Confirm & publish',
      loading: isLoading,
      loadingText: 'Publishing...',
      onClick: onConfirm,
    }}
  >
    <Text>
      Publishing will <strong>apply all price and approval changes.</strong>
    </Text>
  </BaseModal>
);
